export let CoverageIntegrationStatus = /*#__PURE__*/function (CoverageIntegrationStatus) {
  CoverageIntegrationStatus["ACTIVE"] = "active";
  CoverageIntegrationStatus["PAUSED"] = "paused";
  CoverageIntegrationStatus["TRIAL"] = "trial";
  CoverageIntegrationStatus["DELETED"] = "deleted";
  return CoverageIntegrationStatus;
}({});